const chapter = {

	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();
	},
	
	bindUI: function() {
		this.ui.$window = $(window);
		this.ui.$document = $(document);
		
		this.ui.$chapter = $(".js-chapter");
		this.ui.$chapterList = $(".js-chapter-list");
		this.ui.$backdrop = $(".js-chapter-backdrop");
		this.ui.$button_close = $(".js-chapter-close");
		this.ui.$button_toggle = $(".js-chapter-toggle");
	},

	bindEvents: function() {
		this.ui.$button_toggle.on('click', this.toggleChapter.bind(this));
		this.ui.$button_close.on('click', this.toggleChapter.bind(this));
		this.ui.$backdrop.on('click', this.toggleChapter.bind(this));
	},

	toggleChapter: function(e) {
		let $this = $(e.currentTarget);

		if (this.ui.$chapter.hasClass('is-openned')) {
			this.ui.$chapter.removeClass('is-openned');
			this.ui.$backdrop.fadeOut(200);
			this.ui.$chapterList.fadeOut(200);
		} else {
			this.ui.$chapter.addClass('is-openned');
			this.ui.$backdrop.fadeIn(200);
			this.ui.$chapterList.fadeIn(200);
		}
	},

};

export default chapter;
